import {
  Button,
  Grid,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Block, Save, Search } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import TableComponent from "app/common/Component/Table/TableComponent";
import FormikFocusError from "app/common/form/FormikFocusError";
import IconPen from "app/common/Icon/IconPen";
import { formatMoney, getDateTime } from "app/common/LocalFunction";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "app/stores";
import { REGISTRATION_STATUS } from "app/common/LocalConst";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
const RegisterTreatmentPlanAdvicePopup = ({
  open,
  handleClose,
  dataRegisterTreatmentPlan,
  patient,
  onSubmit,
  initialData,
  customerSourceWalkIn,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <PopupForm
      open={open}
      size="xl"
      handleClose={handleClose}
      title={`Chốt liệu trình`}
      formik={{
        initialValues: initialData,
        enableReinitialize: true,
        onSubmit: onSubmit,
      }}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              patient={patient}
              dataRegisterTreatmentPlan={dataRegisterTreatmentPlan}
              customerSourceWalkIn={customerSourceWalkIn}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(
  ({ patient, dataRegisterTreatmentPlan, customerSourceWalkIn }) => {
    const { handleAddTreatmentPlanAdvicePopup } =
      useStore().patientManagementStore.registerTreatmentPlanStore;
    const { t } = useTranslation();

    return (
      <>
        <FormikFocusError />
        <Grid container spacing={1} className=" cards-body">
          <Grid item xs={12} sm={6} md={2}>
            <GlobitsDateTimePicker label="Từ ngày" name="fromDate" />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <GlobitsDateTimePicker label="Đến ngày" name="toDate" />
          </Grid>
          <Grid item xs={12} sm={6} md={8} className="flex align-end">
            <Button className="btn-primary" type="submit">
              <Search />
              Tìm kiếm
            </Button>
          </Grid>
          <Grid item xs={12}>
            <div className="cards-header-popup flex gap-2">
              <h4>Danh sách liệu trình đã chốt</h4>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <TableComponent
              showOrdinalNumbers
              titleNodata={t("noData")}
              data={dataRegisterTreatmentPlan || []}
              rowCss={(row) =>
                REGISTRATION_STATUS.find(
                  (el) => el?.value === row?.pAdviceItemResStatus
                )?.className
              }
              minWidth={"720px"}
              columns={[
                {
                  title: t("action"),
                  field: "action",
                  align: "center",
                  width: "70px",
                  render: (row, index) => (
                    <div className="flex-center gap-2">
                      {row?.pAdviceItemResStatus !==
                        REGISTRATION_STATUS[0].value && (
                        <Tooltip title="Chỉnh sửa">
                          <div
                            onClick={() => {
                              handleAddTreatmentPlanAdvicePopup(
                                row,
                                patient,
                                customerSourceWalkIn
                              );
                            }}
                          >
                            <IconPen />
                          </div>
                        </Tooltip>
                      )}
                    </div>
                  ),
                },
                {
                  field: "service.name",
                  title: t("Liệu trình"),
                  render: (row) => {
                    return (
                      <div className="pl-1 pr-1">
                        <div>
                          <span className="service-code">
                            {row?.clientCard?.code}
                          </span>{" "}
                          <span className="clientCard-name">
                            {row?.clientCard?.name}
                          </span>
                        </div>
                      </div>
                    );
                  },
                },

                {
                  field: "clientCard.name",
                  title: t("Ngày đăng ký"),
                  render: (val) => getDateTime(val?.startDate),
                },
                {
                  field: "quantity",
                  title: t("Số lượng"),
                  align: "right",
                },
                {
                  field: "practitioner.staffName",
                  title: t("Thành tiền"),
                  width: "240px",
                  render: (data) => {
                    return (
                      <div className="total-data-group">
                        <div className="flex justify-between">
                          Thành tiền:{" "}
                          <b>{formatMoney(data?.price * data?.quantity)}</b>
                        </div>
                        <div className="flex justify-between">
                          Giảm giá: <b>{formatMoney(data?.discount)}</b>
                        </div>

                        <div className="flex justify-between">
                          <b
                            className="flex justify-between"
                            style={{ width: "100%" }}
                          >
                            Số tiền (sau giảm):{" "}
                            <b>
                              {formatMoney(
                                data?.price * data?.quantity -
                                  (+data?.discount || 0)
                              )}
                            </b>
                          </b>
                        </div>
                        <div className="flex justify-between">
                          Vat: <b>{formatMoney(+data?.taxTotal)}</b>
                        </div>
                        <div
                          style={{
                            background: "#ccc",
                            width: "100%",
                            height: "1px",
                            margin: "4px 0",
                          }}
                        ></div>
                        <div className="flex justify-between">
                          <b
                            className="flex justify-between"
                            style={{ width: "100%" }}
                          >
                            Tổng thanh toán:{" "}
                            <b>
                              {formatMoney(
                                data?.price * data?.quantity -
                                  (+data?.discount || 0) +
                                  (+data?.taxTotal || 0)
                              )}
                            </b>
                          </b>
                        </div>
                        {data?.allocateDiscount ? (
                          <div>
                            <b
                              className="flex justify-between"
                              style={{ width: "100%" }}
                            >
                              Giảm tổng HĐ:{" "}
                              <b>{formatMoney(data?.allocateDiscount)}</b>
                            </b>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    );
                  },
                },
                {
                  field: "clientCard.name",
                  title: t("Giá"),
                  render: (val) => formatMoney(val?.paiPrice),
                },

                {
                  field: "clientCard.name",
                  title: t("Doanh thu phân bổ"),
                  render: (val) => {
                    return (
                      <>
                        {val?.staffRevenues?.map((staffRevenue, index) => (
                          <div key={index} className="revenue-item">
                            <span className="position">
                              {staffRevenue?.position?.name} -{" "}
                            </span>
                            <b className="staff-name">
                              {staffRevenue?.staff?.staffName
                                ? staffRevenue?.staff?.staffName
                                : "chưa có"}
                            </b>
                            <i className="revenue-percent">
                              {staffRevenue?.percentRevenue}%
                            </i>
                          </div>
                        ))}
                      </>
                    );
                  },
                },

                {
                  field: "clientCard.name",
                  title: t("Trạng thái đăng ký"),
                  align: "center",
                  render: (rowData) => (
                    <span style={{ textAlign: "center", color: "primary" }}>
                      {REGISTRATION_STATUS.find(
                        (el) => el.value === rowData?.pAdviceItemResStatus
                      )?.char || ""}
                    </span>
                  ),
                },
              ]}
            />
          </Grid>
        </Grid>
      </>
    );
  }
);

export default memo(observer(RegisterTreatmentPlanAdvicePopup));
